"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheNovaPathStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="28752" id="the-person-behind-the-protection" className="bg-background py-24 overflow-hidden">
      <div ref={ref} className={cn("max-w-7xl mx-auto px-6 transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="relative order-2 lg:order-1 group">
            <div className="absolute -inset-4 bg-primary/10 rounded-sm blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587918/img/scott_smith_safety_expert_portrait.png" alt="Scott Smith - Safety Consultant" className="relative w-full h-auto object-cover rounded-sm shadow-xl transition-transform duration-500 hover:scale-[1.01]" />
          </div>

          {}
          <div className="flex flex-col justify-center order-1 lg:order-2">
            <div className="mb-4">
              <span className="inline-block px-3 py-1 text-xs font-mono font-bold tracking-widest bg-primary text-primary-foreground border border-transparent rounded-sm uppercase">
                The Expert
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-8 tracking-tighter">
              Industry-Leading Safety Experience
            </h2>
            <div className="space-y-6">
              <p className="text-lg text-secondary/70 leading-relaxed font-sans">
                Scott Smith Consulting is dedicated to helping organizations identify hazards and implement strategic risk mitigation. With <strong className="font-bold text-secondary">over a decade of industry experience</strong>, Scott provides tailored safety audits and compliance programs that turn complex regulatory requirements into clear, manageable solutions for construction and manufacturing clients.
              </p>
              <p className="text-lg text-secondary/70 leading-relaxed font-sans">
                Our approach emphasizes a proactive safety culture through specialized training workshops and emergency response planning.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}